import parse from 'root-domain'

const rootDomain = url => parse(url)

export default {
  rootDomain,
}



// WEBPACK FOOTER //
// ./src/utils/routing/domain.js